import { PRE_BLOCK } from "../../Data/typeDirs"
import { genId } from "../../utils"
// import { ReportNarrative } from "./reportNarrative"



export class PreambleBlock{

  constructor(data = {}){
    this._id = data._id || genId()
    this._reports_v2 = data._reports_v2
    this.created = data.created || Date.now()
    this._createdBy = data._createdBy || null
    this.modified = data.modified
    this._modifiedBy = data._modifiedBy
    this.type = PreambleBlock.getTypeDir()
    this.schema = data.schema || 'preambleBlockSchema'
    this.title = data.title || 'Preamble Block'
    this.textBlock1 = data.textBlock1 || null
    this.textBlock2 = data.textBlock2 || null
    this.preambleImage = data.preambleImage || null
    this.caption = data.caption || null
  }

  static createDefaultPreambleBlock(reportId){
    return new PreambleBlock({
      _reports_v2:reportId,
    })
  }
  



  static getTypeDir() { return PRE_BLOCK }
  static getIndices() { return '_id,_reports_v2' }


}